import CtaDevices from './CtaDevices'

export default CtaDevices
// eslint-disable-next-line import/export
export * from './CtaDevices'
